import context from '../context'
import getComponentKey from '@/utils/getComponentKey'
import { allowErrorDialog } from '@/utils/fetch'

const CLOSED_ITEMS = 'closed_announcements'

const initialState = {
  gridKey: getComponentKey(),
  saving: false,
  entityIdBeingDeleted: null,
  fetching: false,
  announcementsKey: getComponentKey(),
  announcements: []
}

const actionTypes = {
  deleting: 'announcements/deleting',
  deleted: 'announcements/deleted',
  saving: 'announcements/saving',
  saved: 'announcements/saved',
  fetching: 'announcements/fetching',
  fetched: 'announcements/fetched',
  closed: 'announcements/closed',
  error: 'announcements/error',
  reopened: 'announcements/reopened'
}
export const actionCreators = {
  delete: (id) => (dispatch) => {
    dispatch({ type: actionTypes.deleting, data: id })
    context.api.announcementService.delete(id, allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.deleted })
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { entityIdBeingDeleted: null } }))
  },
  save: (item) => (dispatch) => {
    dispatch({ type: actionTypes.saving })
    return context.api.announcementService.save(item, allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.saved })
        return response
      })
      .catch((e) => {
        dispatch({ type: actionTypes.error, update: { saving: false } })
        throw e
      })
  },
  getAnnouncements: () => (dispatch) => {
    dispatch({ type: actionTypes.fetching })
    context.api.announcementService.getAnnouncements(allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.fetched, data: response })
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { fetching: false } }))
  },
  closeAnnouncement: (id) => (dispatch) => {
    const closedItems = getClosedItems()
    closedItems.push(id)
    window.localStorage.setItem(CLOSED_ITEMS, JSON.stringify(closedItems))
    dispatch({ type: actionTypes.closed, data: id })
  },
  reopenAnnouncements: () => (dispatch) => {
    window.localStorage.setItem(CLOSED_ITEMS, JSON.stringify([]))
    dispatch({ type: actionTypes.reopened })
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.deleting: return { ...state, entityIdBeingDeleted: action.data }
    case actionTypes.deleted: return { ...state, entityIdBeingDeleted: null, gridKey: getComponentKey() }
    case actionTypes.saving: return { ...state, saving: true }
    case actionTypes.saved: return { ...state, saving: false, gridKey: getComponentKey() }
    case actionTypes.fetching: return { ...state, fetching: true }
    case actionTypes.fetched: return { ...state, fetching: false, announcementsKey: getComponentKey(), announcements: removeClosedAnnouncements(action.data) }
    case actionTypes.closed: return {
      ...state,
      announcements: state.announcements.map(x => {
        if (x.id === action.data) { return { ...x, isOpen: false } }
        return x
      })
    }
    case actionTypes.error: return { ...state, ...action.update }
    case actionTypes.reopened: return {
      ...state,
      announcements: state.announcements.map(x => {
        return { ...x, isOpen: true }
      })
    }

    default: return state
  }
}
const getClosedItems = () => {
  const json = window.localStorage.getItem(CLOSED_ITEMS)
  if (json) { return JSON.parse(json) }
  return []
}
const isInClosedItems = (id, closedItems) => closedItems.find(x => x === id) !== undefined
const removeClosedAnnouncements = (announcements) => {
  const closedItems = getClosedItems()
  return announcements.map(x => ({ ...x, isOpen: !isInClosedItems(x.id, closedItems) }))
}



// WEBPACK FOOTER //
// ./src/store/announcements.js